import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "./content";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-forest text-bone grain" data-testid="site-footer">
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="flex items-baseline gap-2">
              <span className="font-display text-3xl tracking-tight">Wellknowe</span>
              <span className="overline text-sage pb-1">Ltd</span>
            </div>
            <p className="mt-6 max-w-md text-sage/90 leading-relaxed">
              Locum Advanced Nurse Practitioner services for GP surgeries across the United Kingdom —
              face-to-face clinics, remote triage and remote clinical workflow admin support.
            </p>
          </div>

          <div className="md:col-span-6 md:justify-self-end">
            <span className="overline text-sage">Get in touch</span>
            <div className="mt-6 space-y-4">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-sage-light transition-colors duration-200" data-testid="footer-email">
                <Mail className="h-4 w-4 text-sage" />
                <span>{CONTACT.email}</span>
              </a>
              <a href={`tel:${CONTACT.phone.replace(/\s|\(|\)/g, "")}`} className="flex items-center gap-3 hover:text-sage-light transition-colors duration-200" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-sage" />
                <span>{CONTACT.phone}</span>
              </a>
              <div className="flex items-center gap-3 text-sage/90">
                <MapPin className="h-4 w-4 text-sage" />
                <span>{CONTACT.area}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <span className="font-mono-label text-xs uppercase tracking-[0.16em] text-sage/70">
            &copy; {new Date().getFullYear()} Wellknowe Ltd. All rights reserved.
          </span>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="font-mono-label text-xs uppercase tracking-[0.16em] text-sage/70 hover:text-sage-light transition-colors duration-200"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <span className="font-mono-label text-xs uppercase tracking-[0.16em] text-sage/70">
              Registered in England &amp; Wales
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
